<template>
  <div class="col-12 gift-cart-contents" :id="id">
    <div class="row row-mlr-0 gift-cart-row-in">
      <adv-cart-gift-row-group
        v-for="(cartProductGroup, index) in filteredGiftChoicesByGiftId"
        :key="index"
        :enable-picker="shouldEnablePicker(cartProductGroup.id)"
        :enable-minicart-picker="shouldEnableMinicartPicker(cartProductGroup.id)"
        :mini-cart="miniCart"
        :is-mini-cart-component="isMiniCartComponent"
        :styling-options="stylingOptions"
        :cart-gift-product-group="cartProductGroup"
      ></adv-cart-gift-row-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdvCartGiftRowGroup from './AdvCartGiftRowGroup'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'
import _ from 'lodash'

export default {
  name: 'AdvCartGiftList',
  components: {
    AdvCartGiftRowGroup
  },
  props: {
    giftChoicesFilter: {
      type: Function,
      required: false,
      default: (giftChoicesGroupedByGiftId) => giftChoicesGroupedByGiftId
    }
  },
  mixins: [cartGiftOptionsMixin],
  data () {
    return {
      id: '',
      version: '0.0.1'
    }
  },
  computed: {
    ...mapGetters(['giftChoicesGroupedByGiftId']),
    filteredGiftChoicesByGiftId () {
      return this.giftChoicesFilter(this.giftChoicesGroupedByGiftId)
    },
    giftSliders () {
      return _.filter(
        this.conf.get('sliders', 'slick'),
        (slider) => {
          if (!_.includes(slider.selector, '.slick-checkout-gifts-slider')) { return false }
          return this.jQuery(`#${this.id}`).has(this.jQuery(slider.selector)).length > 0
        }
      )
    }
  },
  methods: {
    updateSliders () {
      _.each(this.giftSliders, (sliderData) => {
        const $slider = this.jQuery(sliderData.selector)
        $slider.not('.slick-initialized').slick(sliderData.settings)
      })
    }
  },
  mounted () {
    this.id = `gift-list-${_.uniqueId()}`
    this.$nextTick(() => {
      this.updateSliders()
    })
  }
}
</script>
